import { City, Pagination, SelectItem, State } from '~/types';
import api from '../../utils/api';

export async function getStates(): Promise<SelectItem[]> {
  const { data } = await api.get<Pagination<State>>('/estados', {
    params: {
      page: 1,
      size: 30,
    },
  });

  const selectableItems: SelectItem[] = data.results?.map(state => ({
    label: state.sg_estado,
    value: state.id_estado,
  }));

  return selectableItems;
}

export async function getCities(uf: string): Promise<SelectItem[]> {
  const { data } = await api.get<City[]>('/municipio', {
    params: {
      uf,
    },
  });

  const selectableItems: SelectItem[] = data?.map(municipio => ({
    label: municipio.descricao,
    value: municipio.id.toString(),
  }));

  return selectableItems;
}
